import { registerBlockType } from "@quillforms/blocks";
import display from "./display";

registerBlockType("thanks", {
  
  attributes: {
   
  },
  display
});